export const options = {
  width: '100%',
  height: 360,
  pointSize: 4,
  lineWidth: 0,
  chartArea: {
    width: '95%',
    height: 334,
    left: 24,
    top: 4
  },
  fontSize: 10,
  fontName: 'Inter',
  areaOpacity: 0.6,
  dataOpacity: 0.6,
  legend: {
    position: 'none'
  },
  hAxis: {
    minValue: 0,
    textStyle: {
      color: '#536283'
    },
    maxTextLines: 1,
    minTextSpacing: 3
  },
  vAxis: {
    maxValue: 10,
    baselineColor: '#edf2f8',
    gridlines: {
      count: 10,
      color: '#edf2f8'
    },
    minorGridlines: {
      count: 0
    },
    textStyle: {
      color: '#536283'
    },
    maxTextLines: 1,
    minTextSpacing: 3
  },
  focusTarget: 'category',
  tooltip: {
    trigger: 'focus',
    isHtml: true
  },
  crosshair: {
    trigger: 'focus',
    orientation: 'vertical',
    color: '#dde6f2'
  }
};

export const activeUsersPeriods = ['Daily', 'Weekly', 'Monthly', 'Yearly'];
